import { useState } from 'react';
import { GuessingStep } from '~/types';
import ChoicesList from './ChoicesList';
import Conclusion from './Conclusion';

export type Choices = 'ShutDown' | 'StayActive';

interface ChoicesProps {
  onNextStep: (step: GuessingStep) => void;
}

export default function Choices({ onNextStep }: ChoicesProps) {
  const [userChoice, setUserChoice] = useState<Choices | null>(null);
  return (
    <>
      {userChoice === null ? (
        <ChoicesList setUserChoice={setUserChoice} />
      ) : (
        <Conclusion userChoice={userChoice} onNextStep={onNextStep} />
      )}
    </>
  );
}
